export default "__VITE_ASSET__bac76e61__"